import styled, { css } from 'styled-components';

export const SliderWrapperStyled = styled.div`
    overflow: hidden;
`;

export const SliderContainerStyled = styled.ul(
    ({ theme }) => css`
        display: flex;
        white-space: nowrap;

        & > * {
            flex-grow: 1;
            flex-shrink: 0;
            min-width: calc(100vw / 2.5 - 40px);
            white-space: normal;

            @media ${theme.mediaQueries.querySm} {
                width: calc(100vw / 4.3 - 40px);
            }

            @media ${theme.mediaQueries.queryMd} {
                width: calc(100vw / 5.3 - 40px);
            }

            @media ${theme.mediaQueries.queryLg} {
                width: auto;
            }

            & + * {
                margin-left: 10px;
            }
        }
    `,
);
